import { queryOptions } from '@tanstack/react-query';
import { versionNotificationFunction } from './versionNotificationQueryFunction';
import { OnSuccessType } from './versionNotificationQuery.type';

export const versionNotificationQueryOptions = ({
  onSuccess,
}: OnSuccessType) => {
  return queryOptions({
    queryKey: ['versionNotif'],
    queryFn: versionNotificationFunction,
    meta: {
      onSuccess: onSuccess,
    },
  });
};
